import { Instance, Table } from '@siposdani87/sui-js';
import { app } from '../app';
import { AdminCouponService } from '@services/adminCouponService';
import { LanguageService } from '@services/languageService';
import { initTable } from '@utils/collectionSetup';
import { AdminController } from './adminController';

export class AdminCouponsIndexController extends AdminController {
    static readonly inject = [
        'instances',
        'adminCouponService',
        'languageService',
    ] as const;

    private table!: Table;

    constructor(
        instances: Instance,
        private adminCouponService: AdminCouponService,
        private languageService: LanguageService,
    ) {
        super(instances);
    }

    protected override _initToolbarButtons(): void {
        this.helper.iconButton('.btn-admin-index', this.dom, () => {
            this.state.goBack('admin.index');
        });

        this.helper.fabButton('.btn-coupons-new', this.dom, () => {
            this.adminCouponService.newDialogByAdmin().then(() => {
                this._drawContent();
            });
        });
    }

    protected override _initTable(): void {
        this.table = initTable(
            this.table,
            this.dom,
            'table',
            this.adminCouponService,
            {
                entityKey: 'coupons',
                fetchData: (params) =>
                    this.adminCouponService.getAll(params),
                extraParams: (params) => params.set('query', this.query),
            },
            [
                {
                    style: () => [
                        'edit',
                        this.languageService.translate('buttons.edit'),
                    ],
                    click: (coupon) => {
                        this.adminCouponService
                            .editDialog(coupon, '/admin/')
                            .then(() => {
                                this._drawContent();
                            });
                    },
                },
            ],
        )!;
    }
}

export const adminCouponsIndexController = app.controller(
    'adminCouponsIndexController',
    AdminCouponsIndexController,
);
